module.exports = __webpack_public_path__ + "static/media/FDACS-title-seal.883f696b.png";